import axios from "@/utils/server.js";
// 获取任务列表
export const getTaskListSer = (datas, type) =>
    axios.get("/task/list/" + type, { params: datas });
// 获取全部任务
export const getAllTaskListSer = (datas) =>
    axios.get("/task/list", { params: datas });
//添加任务
export const saveTaskSer = (datas) =>
    axios.post("/task/new", null, { params: datas });
//删除任务
export const deleteTaskSer = (datas) =>
    axios.put("/task/shanchu", null, { params: datas });
//取消任务
export const cancelTaskSer = (datas) =>
    axios.put("/task/quxiao", null, { params: datas });
//重试任务
export const retryTaskSer = (datas) =>
    axios.put("/task/chongshi", null, { params: datas });
//获取任务详情
export const getTaskSer = (datas) =>
    axios.get("/task/details", { params: datas });
//查询模板
export const getTemplateSer = (datas) =>
    axios.get("/template/format/select", { params: datas });
//查询任务详情
export const getTaskDetailsSer = (data) =>
    axios.get("/task/details", { params: data })